import React, { useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check } from 'lucide-react';
export function NotifyForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setStatus('error');
      setErrorMessage('Please enter a valid email address.');
      return;
    }
    setStatus('submitting');
    // Open the user's SMS app with the email pre-filled, sending to 1-305-877-9092
    const phone = '13058779092';
    const body = encodeURIComponent(`Sign me up for Depinga Café updates: ${email}`);
    window.location.href = `sms:+${phone}?&body=${body}`;
    setTimeout(() => {
      setStatus('success');
      setEmail('');
    }, 1200);
  };
  return <div className="w-full max-w-md mx-auto mt-8 mb-12" data-id="element-54">
      <AnimatePresence mode="wait" data-id="element-55">
        {status === 'success' ? <motion.div key="success" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="bg-mocha/30 border border-red/30 rounded-xl p-6 text-center" data-id="element-56">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-red/20 text-red mb-4" data-id="element-57">
              <Check size={24} data-id="element-58" />
            </div>
            <h3 className="font-serif text-xl text-cream mb-2" data-id="element-59">
              You're on the list!
            </h3>
            <p className="text-pale font-sans text-sm" data-id="element-60">
              We'll let you know when the doors open ☕
            </p>
          </motion.div> : <motion.form key="form" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onSubmit={handleSubmit} className="relative" data-id="element-61">
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-62">
              <div className="relative flex-grow" data-id="element-63">
                <input type="email" value={email} onChange={e => {
              setEmail(e.target.value);
              if (status === 'error') setStatus('idle');
            }} placeholder="Enter your email address" className={`w-full bg-mocha/20 border ${status === 'error' ? 'border-red-400/50' : 'border-pale/20'} rounded-lg px-4 py-3 md:py-4 text-cream placeholder:text-pale/40 focus:outline-none focus:border-red/60 focus:ring-1 focus:ring-red/60 transition-all font-sans text-sm md:text-base`} disabled={status === 'submitting'} aria-label="Email address for notifications" data-id="element-64" />
                <p className="mt-2 text-[11px] font-sans text-pale/50 tracking-wide" data-id="element-65">
                  We'll text your email to{' '}
                  <a href="sms:+13058779092" className="text-pale/80 hover:text-red transition-colors" data-id="element-66">
                    1-305-877-9092
                  </a>
                </p>
              </div>
              <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} type="submit" disabled={status === 'submitting'} className="bg-red hover:bg-[#a30d24] text-cream px-6 py-3 md:py-4 rounded-lg font-sans font-medium text-sm md:text-base transition-colors shadow-[0_0_15px_rgba(200,16,46,0.2)] hover:shadow-[0_0_20px_rgba(200,16,46,0.4)] whitespace-nowrap disabled:opacity-70 flex justify-center items-center min-w-[120px]" data-id="element-67">
                {status === 'submitting' ? <div className="w-5 h-5 border-2 border-cream/30 border-t-cream rounded-full animate-spin" data-id="element-68" /> : 'Notify me'}
              </motion.button>
            </div>

            <AnimatePresence data-id="element-69">
              {status === 'error' && <motion.p initial={{
            opacity: 0,
            y: -10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0
          }} className="absolute -bottom-6 left-2 text-red-400/80 text-xs font-sans" data-id="element-70">
                  {errorMessage}
                </motion.p>}
            </AnimatePresence>
          </motion.form>}
      </AnimatePresence>
    </div>;
}